<template>
  <div id="slider">
    <div v-if="store === 'maturity'" class="image image-left min-h-450">
      <div class="flip-card" v-for="index in content.length" :key="index" :style="`width: ${1 / (content.length) * 100}%`">
        <div class="flip-card-inner">
          <div class="flip-card-front">
            <sb-image
              :src="content[index - 1].img"
              :alt="content[index - 1].alt"
              :class="{'img-inactive' : ((index - 1) > value)}"
              :forceImg=true>
            </sb-image>
          </div>
          <div class="flip-card-back">
            <p v-html="content[index - 1].description"></p>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="image min-h-450">
      <h1 v-if="!content[value].img" class="display-1 text-center">?</h1>
      <sb-image
        v-else
        :src="content[value].img"
        :alt="content[value].alt"
        :forceImg=true>
      </sb-image>
    </div>

    <input type="range" :name="store" :id="store" :max="content.length - 1" min="0" v-model="value" @change="mergeData({[store]: content[value].value})">
    <div class="grid-range-marks">
      <span v-for="i in content.length" :key="i" class="list-inline"></span>
    </div>
    <div v-if="store === 'maturity'" class="grid-range-text">
      <p>We're lagging</p>
      <p>We're fully optimized</p>
    </div>
    <div v-else class="grid-range-text">
      <p v-for="item in content" :key="item" class="list-inline">
        {{item.value}}
      </p>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import SbImage from '../SbImage/SbImage';

export default {
  name: 'RangeSelector',
  components: {
    SbImage
  },
  props: ['content', 'store'],
  data() {
    return {
      value: 0,
    }
  },
  methods: {
    ...mapMutations([
      'mergeData'
    ]),
  },
  mounted() {
    this.value = this.content.findIndex(x => x.value === this.$store.state.selectedValues[this.store])
  }
}
</script>

<style scoped>

  .img-inactive {
    opacity: 0.15;
  }

  .image {
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(0,0,0,0.5);
    margin-top: -4rem;
  }

  .image-left {
    justify-content: flex-start
  }

  .image-left object,
  .image-left img {
    margin: 0;
  }
  .grid-range-marks {
    display: flex;
    justify-content: space-between;
    padding-left: 1.5rem;
    padding-right: 1.2rem;
    margin-bottom: 0.25rem;
    margin-top: -1.25rem;
    pointer-events: none;
  }

  .grid-range-marks > span {
    height: 5px;
    width: 5px;
    background-color: rgba(0,0,0,.5);
    border-radius: 100%;
  }

  .grid-range-text {
    display: flex;
    justify-content: space-between;
    margin-left: -1rem;
    margin-right: -1.25rem;
    color: rgba(0,0,0,.5);
  }

  .grid-range-text > p {
    width: 95px;
    text-align: center;
  }

  .h2 {
    text-align: center;
    font-weight: 300;
  }

  img,
  object {
    max-width: 450px;
    margin: 0 auto;
    display: block;
    transform-style: preserve-3d;
  }

  .min-h-450 {
    min-height: 450px;
  }

  input[type="range"] {
    width: 100%;
    border: 0;
    height: 28px;
    -webkit-appearance: none;
    margin-top: 10px;
    padding-top: 1.5rem;
    padding-bottom: 2rem;
    cursor: pointer;
  }

  input[type=range]:focus {
    outline: none;
  }
  input[type=range]::-webkit-slider-runnable-track {
    width: 100%;
    height: 13px;
    cursor: pointer;
    animate: 0.2s;
    box-shadow: 0px 0px 0px #000000;
    background: #EFEFEF;
    border-radius: 25px;
    border: 0px solid #000000;
  }
  input[type=range]::-webkit-slider-thumb {
    box-shadow: 0px 0px 0px #000000;
    border: 2px solid #58A13E;
    height: 20px;
    width: 39px;
    border-radius: 40px;
    background: #69BF4A;
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -4.5px;
  }
  input[type=range]:focus::-webkit-slider-runnable-track {
    background: #EFEFEF;
  }
  input[type=range]::-moz-range-track {
    width: 100%;
    height: 13px;
    cursor: pointer;
    animate: 0.2s;
    box-shadow: 0px 0px 0px #000000;
    background: #EFEFEF;
    border-radius: 25px;
    border: 0px solid #000000;
  }
  input[type=range]::-moz-range-thumb {
    box-shadow: 0px 0px 0px #000000;
    border: 2px solid #58A13E;
    height: 20px;
    width: 39px;
    border-radius: 40px;
    background: #69BF4A;
    cursor: pointer;
  }
  input[type=range]::-ms-track {
    width: 100%;
    height: 13px;
    cursor: pointer;
    animate: 0.2s;
    background: transparent;
    border-color: transparent;
    color: transparent;
  }

  input[type=range]::-ms-thumb {
    margin-top: 1px;
    box-shadow: 0px 0px 0px #000000;
    border: 2px solid #58A13E;
    height: 20px;
    width: 39px;
    border-radius: 40px;
    background: #69BF4A;
    cursor: pointer;
  }

  input[type="range"]::-moz-range-progress {
    background-color: #69BF4A; 
    height: 13px;
  }

  /* IE*/
  input[type="range"]::-ms-fill-lower {
    height: 13px;
    background-color: #69BF4A; 
  }

  object:not([width]) {
    width: 100%;
    height: 100%;
  }

  .flip-card {
    background-color: transparent;
    width: 300px;
    height: 300px;
  }

  .flip-card:hover .flip-card-inner {
    transform: rotateY(180deg);
  }

  .flip-card-inner {
    position: relative;
    transition: transform 0.6s ease;
    transform-style: preserve-3d;
    width: 100%;
    height: 100%;
  }

  .flip-card-front {
    width: 100%;
  }

  .flip-card-back, .flip-card-front {
    position: absolute;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    height: 100%;
  }

  .flip-card-back {
    background-color: rgba(105, 191, 74, 0.2);
    transform: rotateY(180deg);
    padding: 0.5rem;
    border: 2px solid rgba(105, 191, 74, 1);
    border-radius: 5px;
  }
</style>